<template>
	<div class="erji-content pp50">
		<div class="container">
			<div class="erji-title">
				<h1>专家库</h1>
				<h2>EXPERT LIBRARY</h2>
			</div>
			<div class="erji-content-div">
				<div class="specialist_detail">
					<div class="specialist-name">{{content.title}}</div>
					<div class="danpian-con" v-html="content.body"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:'specialist_detial',
		data(){
			return{
				content:{
					title:'',
					image:'',
					body:''
				}
			}
		},
		methods:{
			res_detail(e){
				this.axios.get('/api/news/newsView?id=' + e)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							this.content = response.data.reslut;
							this.content.body = response.data.reslut.body.replace(
								/<img [^>]*src=['"]([^'"]+)[^>]*>/gi,
								(match, path) => {
									return path.search("http") == -1
										? `<img src='${this.icoURL}/${path}' />`
										: match;
								}
							);
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			}
		},
		created(){
			this.res_detail(this.$route.query.id);
		}
	}
</script>

<style>
</style>